module.exports = __webpack_public_path__ + "static/media/ice-skate.4cd1fb22.svg";